import React, { SVGProps, useContext } from 'react'
import AppContext from '../../app/context'

const CheckedIcon = (props: SVGProps<SVGSVGElement>) => {
  const { state } = useContext(AppContext)

  if (!state.locationDesignConfig?.baseColors) return null

  return (
    <svg
      {...props}
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        width="30"
        height="30"
        rx="4"
        fill={state.locationDesignConfig.baseColors.primary}
      />
      <path
        d="M6 15L12 21L24 9"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default CheckedIcon
